import styles from './style.postcss';
import React from 'react';
import { Tooltip, Button, Icon } from 'omni-common-ui';
import { PaperbasedHomeworkStatus } from 'data/PaperBasedHomework/status';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const MarkButtons = (props) => <div className={styles.MarkButtons}>
  {
    props.title ?
      <Button className={classnames(styles.MarkButtons_button, props.className)}
          autoWidth
          disabled>
        {props.title}
      </Button> :
      null
  }
  <Tooltip text="Complete" className={styles.MarkButtons_buttonContainer}>
    <Button className={styles.MarkButtons_button}
        onClick={() => props.onMarkComplete(props.eventSender)}
        active={props.status === PaperbasedHomeworkStatus.complete}
        autoWidth>
      <Icon id="tick" />
    </Button>
  </Tooltip>
  <Tooltip text="Partial Complete" className={styles.MarkButtons_buttonContainer}>
    <Button className={styles.MarkButtons_button}
        onClick={() => props.onMarkPartialComplete(props.eventSender)}
        active={props.status === PaperbasedHomeworkStatus.partialcomplete}
        autoWidth>
      <Icon id="tick" className={styles.MarkButtons_PartialIcon} />
    </Button>
  </Tooltip>
  <Tooltip text="Incomplete" className={styles.MarkButtons_buttonContainer}>
    <Button className={styles.MarkButtons_button}
        onClick={() => props.onMarkIncomplete(props.eventSender)}
        active={props.status === PaperbasedHomeworkStatus.incomplete}
        autoWidth>
      <Icon id="cross" />
    </Button>
  </Tooltip>
  <Tooltip text="Not Applicable" className={styles.MarkButtons_buttonContainer}>
    <Button className={styles.MarkButtons_button}
        onClick={() => props.onMarkNA(props.eventSender)}
        active={props.status === PaperbasedHomeworkStatus.notapplicable}
        autoWidth>
      N/A
    </Button>
  </Tooltip>
</div>;

MarkButtons.propTypes = {
  title: PropTypes.string,
  status: PropTypes.oneOf(Object.values(PaperbasedHomeworkStatus)),
  eventSender: PropTypes.string.isRequired,
  onMarkComplete: PropTypes.func.isRequired,
  onMarkIncomplete: PropTypes.func.isRequired,
  onMarkPartialComplete: PropTypes.func.isRequired,
  onMarkNA: PropTypes.func,
  canSeeNotApplicable: PropTypes.bool,
  className: PropTypes.string,
};

export default MarkButtons;



// WEBPACK FOOTER //
// ./containers/Group/Homework/PaperBased/MarkHomeworkDayView/Student/MarkButtons/component.jsx